const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  translationMessages: (communeId: string, locale: string) =>
    `${apiUrl}/v2/commune/${communeId}/i18n/locale/${locale}/translation`,
  walletTranslationMessages: (communeId: string, locale: string) =>
    `${apiUrl}/v2/commune/${communeId}/i18n/locale/${locale}/walletTranslation`,
  sendFeedback: (communeId: string) => `${apiUrl}/v2/feedback/${communeId}`,
  apiInfo: `${apiUrl}/v2/info`,
};
